module.exports = __webpack_public_path__ + "img/login-logo.2b21b2e2.png";